import { searchVolopsRouteReference } from 'modules/search/routing/search.routes';
import { AppRouteGroup } from 'routing/classes/AppRouteGroup';

export const embedSearchWidgetRouteGroup = new AppRouteGroup(
  '/:lang/embed-search-widget/:embedSearchWidgetId',
);

// Volops

export const embedSearchWidgetVolopsRouteGroup =
  embedSearchWidgetRouteGroup.subgroup('volops');

export const embedSearchWidgetSearchVolopsRoute =
  embedSearchWidgetVolopsRouteGroup.rootRoute(
    searchVolopsRouteReference.searchParams,
  );

export const embedSearchWidgetViewVolopRoute =
  embedSearchWidgetVolopsRouteGroup.route(':volopId');
